import { Fragment, useCallback } from "react";
import { useAppStore } from "@/common/store/appStore";
import SearchIcon from "./images/icons/search.svg?react";
import MenuIcon from "./images/icons/menu.svg?react";
import { AnimatedSearch } from "@/components/search/AnimatedSearch";
import { BurgerMenu } from "@/components/burger-menu/BurgerMenu";
import "./MainHeaderV2.scss";

export const MainHeaderV2 = () => {
  const isSearchBarOpen = useAppStore((state) => state.isSearchBarOpen);
  const toggleSearchBar = useAppStore((state) => state.toggleSearchBar);
  const toggleBurgerMenu = useAppStore((state) => state.toggleBurgerMenu);

  const handleBurgerMenuButton = useCallback(() => {
    toggleBurgerMenu();
  }, [toggleBurgerMenu]);

  const onOpenSearch = useCallback(() => {
    toggleSearchBar();
  }, [toggleSearchBar]);

  return (
    <Fragment>
      <div className="mainHeaderV2">
        {!isSearchBarOpen && <button className="menuBtn" onClick={handleBurgerMenuButton}><MenuIcon /></button>}
        <AnimatedSearch />
        {!isSearchBarOpen && <button className="searchBtn" onClick={onOpenSearch}><SearchIcon /></button>}
      </div>
      <BurgerMenu />
    </Fragment>
  );
};
